import type { HelpFile } from '../../types/help'
import { SqlEditorDialogTestIds } from '../../../testids/SqlEditorDialogTestIds'

export const sqlEditorDialogHelp: HelpFile = {
  docPage: '/docs/admin/sql-attributes',
  texts: {
    [SqlEditorDialogTestIds.sqlEditorDialog]: 'Verfasse die SQL-Anweisung, die dieses Attribut auflöst. Gebundene Parameter werden als benannte Platzhalter übergeben.',
    [SqlEditorDialogTestIds.sqlParametersHint]: 'Gebundene Parameter werden mit der Syntax `:name` referenziert. Die verfügbaren Parameternamen sind oben aufgeführt.',
    [SqlEditorDialogTestIds.sqlValidationError]: 'Die Abfrage hat die Validierung nicht bestanden — Details siehe Meldung. Speichern ist deaktiviert, bis die Abfrage fehlerfrei geparst wird.',
    [SqlEditorDialogTestIds.sqlEditorApply]: 'Die Abfrage auf das Attribut anwenden und den Dialog schließen. Beim Speichern wird die Abfrage erneut validiert.',
  },
}
